<script setup>
import { ChannelIcon } from '@dashhudson/dashing-ui/channel-icon';
import { Chip } from '@dashhudson/dashing-ui/chip';
import { Column, DataTable } from '@dashhudson/dashing-ui/data-table';
import { RowTitle } from '@dashhudson/dashing-ui/row-title';

const props = defineProps({
  posts: { type: Array, required: true },
  loading: { type: Boolean, default: false },
  drawerId: { type: String, required: true },
  onRowClick: { type: Function, required: true },
  canLoadMore: { type: Function, required: true },
  onLoadMore: { type: Function, required: true },
  emptyState: { type: Object, default: () => ({ message: 'No data found' }) },
});

const handleRowClick = (event) => {
  const row = event.data;
  props.onRowClick(row);
};
</script>

<template>
  <DataTable
    :value="posts"
    :loading="loading"
    :empty-state="emptyState"
    :infinite-scroll="{
      target: `#${drawerId}`,
      onLoadMore: onLoadMore,
      canLoadMore: canLoadMore,
      loadOnMount: false,
    }"
    class="!pt-0 [&_tbody_td]:h-[112px]"
    clickable
    data-key="sourceId"
    @row-click="handleRowClick"
  >
    <Column field="title" header="Name or Handle" class="!min-w-[280px]">
      <template #body="{ data }">
        <RowTitle
          :media="data.src"
          :title="data.title"
          :subtitle="data.postDate"
          :avatar="data.avatar"
        />
      </template>
    </Column>

    <Column field="caption" header="Caption/Comment" class="!max-w-[400px]">
      <template #body="{ data }">
        <div v-dash-tooltip="data.displayCaption" class="line-clamp-5">
          {{ data.displayCaption }}
        </div>
      </template>
    </Column>

    <Column header="Mention Type" class="!w-[140px]">
      <template #body="{ data }">
        <span>{{ data.mentionType }}</span>
      </template>
    </Column>

    <Column field="channel" header="Channel" class="!w-[120px]">
      <template #body="{ data }">
        <div class="flex items-center gap-2">
          <ChannelIcon :channel="data.channel" size="lg" />
          <span>{{ data.channelName }}</span>
        </div>
      </template>
    </Column>

    <Column header="Sentiment" class="!w-[140px]">
      <template #body="{ data }">
        <Chip v-if="data.sentimentChip" v-bind="data.sentimentChip" />
      </template>
    </Column>
  </DataTable>
</template>
